export default {
  // 导航栏
  nav: {
    brand: 'Fast DXF Viewer',
    docs: 'Blogs'
  },
  
  // Hero区域
  hero: {
    badge: 'Professional · Efficient · Modern',
    title: 'Next Generation',
    titleHighlight: 'Fast DXF Viewer',
    description: 'A modern DXF file preview tool built with WebGL technology, supporting large file fast rendering, layer control, precise measurement and other professional functions. Making CAD file sharing simple and efficient.',
    
    // 快速开始表单
    quickStart: {
      title: 'Get Started',
      subtitle: 'Enter DXF file URL to start preview',
      urlPlaceholder: 'https://example.com/your-file.dxf',
      titlePlaceholder: 'Custom title (optional)',
      showLayerLabel: 'Show layer panel',
      showBackLabel: 'Show back button',
      submitButton: 'Start Preview'
    }
  },
  
  // 功能特性
  features: {
    title: 'Powerful Features',
    subtitle: 'DXF viewing experience designed for modern engineers',
    
    fastLoading: {
      title: 'Fast Loading',
      description: 'WebGL hardware acceleration, large files open instantly'
    },
    layerControl: {
      title: 'Layer Control',
      description: 'Precisely control the display and hiding of each layer'
    },
    cloudAccess: {
      title: 'Cloud Access',
      description: 'No installation required, direct browser access to cloud files'
    },
    preciseMeasurement: {
      title: 'Precise Measurement',
      description: 'Built-in measurement tools for accurate dimension information'
    },
    secureReliable: {
      title: 'Secure & Reliable',
      description: 'Local processing, data not uploaded to servers'
    },
    responsiveDesign: {
      title: 'Responsive Design',
      description: 'Perfect adaptation for desktop and mobile devices'
    }
  },
  
  // API文档
  api: {
    title: 'Usage Guide',
    subtitle: 'Quick access and configure the viewer through URL parameters',
    
    basic: {
      title: 'Basic viewer access',
      example: '/viewer?dxfUrl=https://example.com/drawing.dxf'
    },
    showLayer: {
      title: 'Show layer control panel',
      example: '/viewer?dxfUrl=https://example.com/drawing.dxf&showLayer=true'
    },
    customTitle: {
      title: 'Custom page title',
      example: '/viewer?dxfUrl=https://example.com/drawing.dxf&title=My Drawing'
    },
    showBack: {
      title: 'Hide back button',
      example: '/viewer?dxfUrl=https://example.com/drawing.dxf&showBack=false'
    }
  },
  
  // 页脚
  footer: {
    brand: 'Fast DXF Viewer',
    docs: 'Blogs',
    about: 'About',
    contact: 'Contact: fn9170@gmail.com',
    copyright: '© 2024 bytethink.dev. All rights reserved.'
  },
  
  // DXF Viewer Component
  dxfViewer: {
    loading: {
      font: 'Loading fonts, please wait...',
      fetch: 'Downloading file, please wait...',
      parse: 'Parsing file, please wait...',
      prepare: 'Preparing drawing, please wait...'
    },
    error: {
      occurred: 'Error occurred'
    }
  },

  // 常用词汇
  common: {
    example: 'Example',
    get: 'GET',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    language: 'Language'
  },
  
  // SEO相关
  seo: {
    title: 'Fast DXF Viewer - Professional Online DXF File Viewer',
    description: 'Professional online DXF file viewer with WebGL acceleration. View CAD drawings in browser with layer control, measurement tools, and cloud access. No installation required.',
    keywords: 'Fast DXF Viewer, CAD viewer, online DXF, WebGL, drawing viewer, layer control, measurement tools, cloud access'
  },

  // 定价页面
  pricing: {
    nav: {
      home: 'Home',
      pricing: 'Pricing'
    },
    hero: {
      title: 'Enterprise DXF Solutions',
      description: 'Unlock the full potential of DXF viewing with our private deployment solutions. Get enhanced security, custom features, and dedicated support for your organization.'
    },
    featured: 'Most Popular',
    plans: {
      free: {
        title: 'Free Online',
        period: 'forever',
        features: [
          'Online DXF viewing',
          'Basic layer controls',
          'WebGL acceleration',
          'Community support',
          'No registration required'
        ],
        cta: 'Use Free Version'
      },
      enterprise: {
        title: 'Private Deployment',
        period: 'one-time',
        features: [
          'Complete Docker package',
          'Self-hosted deployment',
          'No data leaves your network',
          'Custom branding options',
          'Advanced security features',
          'Priority email support',
          'Installation documentation',
          'One year of updates'
        ],
        cta: 'Purchase Now'
      },
      custom: {
        title: 'Custom Solution',
        price: 'Contact Us',
        features: [
          'Custom feature development',
          'API integrations',
          'White-label solutions',
          'On-premise training',
          'Dedicated support',
          'Service level agreements',
          'Custom deployment',
          'Maintenance contracts'
        ],
        cta: 'Contact Sales'
      }
    },
    features: {
      title: 'Why Choose Private Deployment?',
      private: {
        title: 'Complete Data Privacy',
        description: 'Your DXF files never leave your network. Process sensitive engineering drawings with complete confidence and compliance.'
      },
      secure: {
        title: 'Enterprise Security',
        description: 'Built-in security features, user authentication, and access controls to meet your organization\'s security requirements.'
      },
      performance: {
        title: 'Optimized Performance',
        description: 'Deploy on your own infrastructure for maximum performance and control over resources and scaling.'
      },
      support: {
        title: 'Dedicated Support',
        description: 'Get priority support from our team with guaranteed response times and direct access to developers.'
      }
    },
    contact: {
      title: 'Ready to Get Started?',
      description: 'Have questions about our enterprise solutions? Our team is here to help you find the perfect fit for your organization.',
      responseTime: '24-hour response time',
      emailSubject: 'Enterprise DXF Viewer Inquiry',
      emailBody: 'Hi, I\'m interested in learning more about the private deployment options for DXF Viewer. Please provide more information about:\n\n- Pricing and licensing\n- Technical requirements\n- Implementation timeline\n- Support options\n\nThank you!',
      whatsappMessage: 'Hi! I\'m interested in the Enterprise DXF Viewer - Private Deployment solution. Could you please provide more information about pricing, technical requirements, and implementation timeline? Thank you!'
    },
    seo: {
      title: 'Enterprise DXF Viewer - Private Deployment Solutions',
      description: 'Get a private deployment of DXF Viewer for your organization. Docker-based solution with enhanced security, custom features, and dedicated support.',
      keywords: 'DXF viewer enterprise, private deployment, Docker DXF viewer, CAD viewer hosting, self-hosted DXF, enterprise CAD solutions'
    }
  },

  // 博客页面
  blog: {
    title: 'Blog',
    subtitle: 'Latest insights and tutorials about DXF, CAD, and engineering workflows',
    readMore: 'Read More',
    backToBlog: 'Back to Blog',
    publishedOn: 'Published on',
    author: 'Author',
    tags: 'Tags',
    relatedPosts: 'Related Posts',
    noPostsFound: 'No blog posts found.',
    searchPlaceholder: 'Search articles...',
    allCategories: 'All Categories',
    seo: {
      title: 'DXF Viewer Blog - CAD Tips, Tutorials & Industry Insights',
      description: 'Discover the latest tips, tutorials, and insights about DXF files, CAD workflows, and engineering best practices.',
      keywords: 'DXF blog, CAD tutorials, engineering tips, DWG to DXF conversion, CAD best practices'
    }
  }
}
